import { useDispatch, useSelector } from 'react-redux';
import { updateScatterChartStyleOptions } from '../../redux/ChartPoperties/ChartControlsActions';
import SliderWithInput from './SliderWithInput';
import SwitchWithInput from './SwitchWithInput';
import { RootState } from '../../redux';

const ScatterStyles = ({ iconColor }: { iconColor?: string }) => {
  const dispatch = useDispatch();

  const { chartControls, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  }));

  const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const currentControls = chartControls.properties[propKey] || {};

  let opacity = currentControls.scatterPlotChartControls?.opacity ?? 50;
  let enableBubbleBorder = currentControls.scatterPlotChartControls?.enableBubbleBorder ?? false;
  let bubbleSize = currentControls.scatterPlotChartControls?.bubbleSize ?? 20;
  let bubbleBorderWidth = currentControls.scatterPlotChartControls?.bubbleBorderWidth ?? 2;

  const handleUpdate = (key: string, value: any) => {
    dispatch(updateScatterChartStyleOptions(propKey, key, value));
  };

  return (
    <div style={{ padding: '0px 5px 0px 5px' }}>
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Bubble Border
      </div>
      <div
        className="switchLabel"
        style={{
          width: '50%',
          marginTop: '5px',
          marginLeft: '39px',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        <SwitchWithInput
          isChecked={enableBubbleBorder}
          onSwitch={() => {
            handleUpdate('enableBubbleBorder', !enableBubbleBorder);
          }}
        />
      </div>

      {enableBubbleBorder && (
        <>
          <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
            Border Width
          </div>
          <SliderWithInput
            sliderValue={bubbleBorderWidth}
            sliderMinMax={{ min: 1, max: 10, step: 1 }}
            changeValue={(val) => handleUpdate('bubbleBorderWidth', val)}
          />
        </>
      )}

      <div
        style={{
          borderBottom: '1px solid #ccc',
          margin: '25px 4px 10px 4px',
        }}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Bubble Opacity
      </div>
      <SliderWithInput
        sliderValue={opacity}
        sliderMinMax={{ min: 30, max: 100, step: 1 }}
        changeValue={(val) => handleUpdate('opacity', val)}
        percent={true}
      />

      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Bubble Size
      </div>
      <SliderWithInput
        sliderValue={bubbleSize}
        sliderMinMax={{ min: 5, max: 50, step: 1 }}
        changeValue={(val) => handleUpdate('bubbleSize', val)}
      />
    </div>
  );
};

export default ScatterStyles;
